// Temporary polyfill to workaround where the vue router is currently used in some react files
export const router = {
  push: (route: any) => {
    return window.APP?.$router?.push(route);
  },
  replace: (route: any) => {
    return window.APP?.$router?.replace(route);
  },
  resolve: (route: any) => {
    return window?.APP.$router?.resolve(route);
  },
};

type Dictionary<T> = { [key: string]: T };

type WithoutRefreshParams = {
  name?: string;
  params?: Dictionary<string>;
  query?: Dictionary<string>;
};

export const redirectWithoutMapRefresh = ({ name, params, query }: WithoutRefreshParams) => {
  const { href } = router.resolve({
    name,
    params,
    query,
  });
  window.history.pushState({}, "", href);
};
